module.exports = __webpack_public_path__ + "img/fw2.0252313e.png";